import { SchichttauschAntragsContent } from '@/domain/navigation/benachrichtigungen/components/antragsSheet/sheetContent';
import { useSheetContext } from '@/domain/navigation/benachrichtigungen/components/antragsSheet/SheetContext';
import { DetailWrapper } from '@/domain/navigation/benachrichtigungen/components/details/shared/DetailWrapper';
import { getTranslationKeyForDay } from '@/domain/navigation/benachrichtigungen/components/details/shared/getTranslationKeyForDay';
import { SchichttauschAntrag } from '@/domain/navigation/benachrichtigungen/types/SchichttauschAntrag';
import { mapMarkierung } from '@/domain/navigation/benachrichtigungen/utils/mapMarkierung';
import { faCircle } from '@fortawesome/pro-solid-svg-icons';
import { CSSVariables, FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

export default function SchichttauschDetail({
  benachrichtigung,
}: {
  benachrichtigung: SchichttauschAntrag;
}) {
  const { t } = useTranslation();
  const context = useSheetContext();

  return (
    <DetailWrapper
      mitarbeiter={benachrichtigung.mitarbeiter}
      onClick={() => {
        context.ctx.setContent(
          new SchichttauschAntragsContent({ antrag: benachrichtigung }),
        );
        context.ctx.setOpen(true);
      }}
      content={
        <div className="rounded-md p-2 border border-neutrals-300 flex gap-1 items-baseline">
          <FontAwesomeIcon
            icon={faCircle}
            className="max-w-2.5 max-h-2.5 text-(--dot-color)"
            style={
              {
                '--dot-color':
                  mapMarkierung[
                    benachrichtigung.schicht.arbeitsbereich.markierung
                  ].base,
              } as React.CSSProperties & CSSVariables
            }
          />
          <div className="text-xs">
            <div>{`${t(
              getTranslationKeyForDay(benachrichtigung.schicht.beginn.day()),
            )}., ${benachrichtigung.schicht.beginn.format('DD.MM.YYYY')}`}</div>
            <div className="text-neutrals-700">{`${benachrichtigung.schicht.beginn.format(
              'HH:mm',
            )} – ${benachrichtigung.schicht.ende.format('HH:mm')} Uhr`}</div>
          </div>
        </div>
      }
    />
  );
}
